import { FieldValues, Control, Path } from 'react-hook-form';

import { FormControl, FormMessage, FormField, FormItem } from '../form';
import { Switch } from '../switch/switch';

interface FormSwitchProps<T extends FieldValues = FieldValues> {
  formControl: Control<T>;
  hideErrorMessage?: boolean;
  disabled?: boolean;
  name: Path<T>;
}

export function FormSwitch<T extends FieldValues>({
  hideErrorMessage,
  formControl,
  disabled,
  name,
}: FormSwitchProps<T>) {
  return (
    <FormField
      render={({ field, fieldState }) => (
        <FormItem>
          <FormControl>
            <Switch
              onCheckedChange={field.onChange}
              hasError={!!fieldState.error}
              checked={field.value}
              disabled={disabled}
            />
          </FormControl>
          {!hideErrorMessage && <FormMessage />}
        </FormItem>
      )}
      control={formControl}
      name={name}
    />
  );
}
